import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const RoundedBolt = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 30 29'} {...props}>
    <svg>
      <g id="Group 1430">
        <circle id="Ellipse 36" cx="14.9858" cy="14.6658" r="14.136" fill="#3E4448" />
        <g id="Group 1311">
          <path
            id="Vector"
            d="M19.9824 13.1438C19.8017 12.818 19.4584 12.6158 19.0858 12.6158H16.6124L17.0323 7.57594C17.071 7.10999 16.7898 6.67709 16.3483 6.52293C15.9074 6.36927 15.4172 6.53343 15.1579 6.92232L10.033 14.6097C9.82327 14.9243 9.80376 15.3287 9.98218 15.662C10.1604 15.9953 10.5077 16.2033 10.8858 16.2033H13.3664L12.9388 21.7621C12.9025 22.2326 13.1923 22.667 13.6407 22.8144C13.746 22.8492 13.8541 22.8657 13.9607 22.8657C14.3066 22.8657 14.6386 22.6898 14.8298 22.384L19.9548 14.1841C20.1525 13.868 20.1628 13.4699 19.9824 13.1438Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
)
export default RoundedBolt
